import { isAdditionalFieldVisible } from "./commerceItemVisibility";

export const getPublicCommerceItems = (eventData) =>
  (eventData?.additionalFields || []).filter(
    (field) => field?.fieldType === "CommerceItem" &&
      field.fieldName && !field.fieldAdminOnly,
  );

export const shouldWaitlistForCommerce = (
  eventData,
  { eventSoldCount = 0, itemSoldCounts = {} } = {},
) => {
  if (!eventData?.allowWaitlist || !eventData?.waitlistWhenCommerceUnavailable) {
    return false;
  }
  const items = getPublicCommerceItems(eventData);
  if (!items.length) return false;

  return !items.some((item) => {
    if (!isAdditionalFieldVisible(item, {}, eventData.additionalFields)) {
      return false;
    }
    let available = Math.max(Math.floor(Number(item.fieldMax) || 0), 0);
    if (item.fieldCapacity === "itemCapacity" &&
        item.fieldCapacityNum !== "" && item.fieldCapacityNum != null) {
      available = Math.min(
        available,
        Number(item.fieldCapacityNum) - (itemSoldCounts[item.fieldName] || 0),
      );
    }
    if (item.fieldCapacity === "eventCapacity" &&
        eventData.capacity !== "" && eventData.capacity != null) {
      available = Math.min(available, Number(eventData.capacity) - eventSoldCount);
    }
    return available >= 1;
  });
};

export const getCommerceSelectionError = (eventData, registration) => {
  if (!eventData?.requireCommerceItem || registration?.status === "Waitlist") {
    return "";
  }
  const items = getPublicCommerceItems(eventData);
  if (!items.length) return "";
  const hasSelection = items.some((item) => {
    const quantity = Number(registration?.[item.fieldName]);
    return Number.isInteger(quantity) && quantity > 0 &&
      quantity <= Number(item.fieldMax) &&
      isAdditionalFieldVisible(item, registration, eventData.additionalFields);
  });
  return hasSelection
    ? ""
    : "Select at least one available commerce item to complete your registration.";
};

export const clearCommerceForWaitlist = (eventData, registration) => {
  const next = {
    ...registration,
    status: "Waitlist",
    sessionId: null,
    sessionItemId: null,
    sessionItem: "",
    sessionDate: "",
    sessionTime: "",
    sessionEndDate: "",
    sessionEndTime: "",
    sessionLabel: "",
    sessionLink: "",
    sessionLinkLabel: "",
    sessionICS: "",
    subCost: "$0.00",
    taxCost: "$0.00",
    totalCost: "$0.00",
  };
  for (const item of eventData?.additionalFields || []) {
    if (item.fieldType !== "CommerceItem" || !item.fieldName) continue;
    next[item.fieldName] = 0;
    for (const suffix of ["Cost", "TaxCost", "SubCost"]) {
      next[item.fieldName + suffix] = 0;
    }
  }
  delete next.paymentMethod;
  delete next.paymentAttemptId;
  return next;
};
